import { render, staticRenderFns } from "./AddNewEmailDomainModal.vue?vue&type=template&id=673c2258&scoped=true&"
import script from "./AddNewEmailDomainModal.vue?vue&type=script&lang=js&"
export * from "./AddNewEmailDomainModal.vue?vue&type=script&lang=js&"
import style0 from "./AddNewEmailDomainModal.vue?vue&type=style&index=0&id=673c2258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673c2258",
  null
  
)

export default component.exports